import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import error from '../../assets/images/error.png';
function PageNotFound() {
    const navigate = useNavigate();
  return (
      <div className='flex flex-col items-center justify-center h-screen'>
        <img src={error} alt="404 Error" className="w-1/2 mb-4 h-1/2" />
        <h2 className='text-2xl font-bold'>Page Not Found</h2>
        <Button onClick={() => navigate("/")}>/ Home</Button>
    </div>
  )
}

export default PageNotFound